var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 12.8334C6.6269 12.8334 7 12.4603 7 12C7 11.5398 6.6269 11.1667 6.16667 11.1667C5.70643 11.1667 5.33333 11.5398 5.33333 12C5.33333 12.4603 5.70643 12.8334 6.16667 12.8334Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.8334C12.4602 12.8334 12.8333 12.4603 12.8333 12C12.8333 11.5398 12.4602 11.1667 12 11.1667C11.5398 11.1667 11.1667 11.5398 11.1667 12C11.1667 12.4603 11.5398 12.8334 12 12.8334Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 12.8334C18.2936 12.8334 18.6667 12.4603 18.6667 12C18.6667 11.5398 18.2936 11.1667 17.8333 11.1667C17.3731 11.1667 17 11.5398 17 12C17 12.4603 17.3731 12.8334 17.8333 12.8334Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDots);
export default __webpack_public_path__ + "static/media/dark-dots.f8c102c1bff0f81d3db2eb283e112ed4.svg";
export { ForwardRef as ReactComponent };